export default "__VITE_ASSET__CciRO$Xp__"